import { render } from "./PromotionProductCreateComponent.vue?vue&type=template&id=729cdc3e"
import script from "./PromotionProductCreateComponent.vue?vue&type=script&lang=js"
export * from "./PromotionProductCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/promotions/product/PromotionProductCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "729cdc3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('729cdc3e', __exports__)) {
    api.reload('729cdc3e', __exports__)
  }
  
  module.hot.accept("./PromotionProductCreateComponent.vue?vue&type=template&id=729cdc3e", () => {
    api.rerender('729cdc3e', render)
  })

}


export default __exports__